import React, { useState, useEffect } from 'react'
import styled from "styled-components";

import WalletModal from "@/components/WalletModal/Modal";
import { ethers } from "ethers";
import { ReactSVG } from 'react-svg'
import ScrollDown from '@/assets/svg/scroll-down.svg'
import GreenR from '@/assets/svg/greenR.svg'
import YellowR from '@/assets/svg/yellowR.svg'
import MintModal from "@/components/MintModal/Modal";
import NftBanner from "@/components/NftBanner/index";
import MintResult from "@/components/MintResult/Modal";
import { useNavigate, Outlet } from "react-router-dom";
// import mounse from '@/assets/imgs/coinbase.png'

import Nav from "@/components/Nav/index";
import { arbitrum } from 'wagmi/chains'
import { useNetwork, useSwitchNetwork, useBalance, useContractReads, useAccount } from 'wagmi'
import { useToastContext } from "@/contexts/ToastContext";
import { NFTCA, nftAbi, GochaCA } from '@/utils/abi'

export default function Mint() {
  const { isConnected } = useAccount();
  const [isOpen, setIsOpen] = useState(false);
  const [isOpen2, setIsOpen2] = useState(false);
  const [isOpen3, setIsOpen3] = useState(false);
  const [seconds, setSeconds] = useState(3)
  const [gacha, setGacha] = useState(0)
  const [minted, setminted] = useState([])
  const [nums, setNums] = useState(0)
  const navigate = useNavigate();
  const { address } = useAccount();

  const handleMint = ()=>{    
    if(!isConnected) return setIsOpen3(true)
    if(nums[0] < 1) return
    setIsOpen(true)
  }
  
  const { data:lister, isError, isLoading } = useContractReads({
    contracts:[
      {
      address: NFTCA,
      abi: nftAbi,
      functionName: 'currentPhraseTotalLeft',
    },
      {
      address: NFTCA,
      abi: nftAbi,
      functionName: 'currentPhraseTotalSupply',
    },
  ],
    watch:true
  })


  useEffect(() => {

    // var future = new Date(1680094800000);
    // var now = new Date();
    // var timeDiff = future - now.getTime();
    // alert(timeDiff)
    // if(timeDiff > 0 || !timeDiff){
    //   navigate('/');
    // }    
    setNums(
      (lister||[]).map(i => parseInt(i))
    )
  }, [lister])


  const { data:GachaBalance } = useBalance({
    address,
    token: GochaCA,
    watch: true
  })  
  const mintCb = (e)=>{
    setIsOpen2(true)    
    setminted(e)    
  }
  useEffect(() => {
    setGacha(Math.floor(GachaBalance?.formatted || 0))
  }, [GachaBalance])
  
  return (
    <MintWrapper>
      <div className='main-top'>
          <NftBanner/>
          <div className='main-desc'>
            <div className='top'>
              <div className='desc-title'>Jungle Squad</div>
              <div className='divs'>
                <div className='div-left'>
                  <span>Phase 3 Supply</span>
                  <span>Mint price</span>
                  <span>Mint limit</span>
                </div>
                <div className='div-right'>
                  <span>{nums[1] || 950}</span>
                  <span>1 gacha coin</span>
                  <span>3 max per tx</span>
                </div>
              </div>
              <div className='link-a'>Learn how to<a className='get-gacha' href="https://twitter.com/Jungle_Fi/status/1636660688759459840" target="blank">get gacha</a></div>
            </div>
            <div className='bot'>
              <div className='left-num'>{nums[0]} Left</div>               
              <div className="mint-btn" onClick={handleMint}>
                <span className={`${nums[0] < 1 ? 'out' : ''}`}>{nums[0] < 1 ? 'All snatched up!' : 'MINT'}</span>
              </div>
            </div>
          </div>
      </div>
      {isOpen && <MintModal isOpen={isOpen} handleClose={() => setIsOpen(false)} gacha={gacha} mintCb={mintCb}/>}
      <MintResult isOpen={isOpen2} handleClose={() => setIsOpen2(false)} minted={minted}/>
      <WalletModal handleClose={() => setIsOpen3(false)} isOpen={isOpen3} />
    </MintWrapper>
  )
}
const MintWrapper = styled.div`
  display: flex;
  justify-content: center;
  min-width: 1260px;
  
  /* cursor: url(mounse), auto; */
  @media only screen and (max-width: 1200px) {
    .nav-wrapper {
      display: none;
    }
  }
    
  .main-top{
    display: flex;
    justify-content: space-between;
    margin-top: 54px;
    .main-left{
      display: flex;
    }
  }
  
  .divs{
    display: flex;
    font-size: 18px;
    line-height: 26px;
    span + span{
      margin-top: 30px;
    }
    .div-left{
      display: flex;
      flex-direction: column;
      color: rgba(255, 255, 255, 0.6);
      width: 142px;
      span{

      }
    }
    .div-right{
      display: flex;
      flex-direction: column;
      padding-left: 20px;
      padding-top: 1px;
      span{

      }
    }
  }
  .main-desc{
    padding-left: 73px;
    padding-right: 187px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    margin-top: -6px;
    .desc-title{
      font-weight: 600;
      font-size: 56px;
      line-height: 78px;      
      color: #32DE86;
      padding-bottom: 30px;
    }    
    .link-a{
      margin-top: 39px;
      font-weight: 400;
      font-size: 20px;
      line-height: 28px;
      color: #32DE86;
      a{
        text-decoration: underline;
        padding-left: 3px;
        color: #32DE86;
        text-decoration-color: #32DE86;
        font-weight: normal;
      }
    }
    .bot{
      margin-top: 70px;
      .mint-btn{
        width: 388px;
        height: 58px;
        line-height: 58px;
        background: rgba(50, 222, 134, 0.8);
        border-radius: 12px;
        text-align: center;
        font-weight: 600;
        font-size: 24px;        
        color: #fff;
        cursor: pointer;
        .out{
          background: linear-gradient(90.31deg, #30EB4E 0.27%, #F7973F 26.71%, #D0AD31 54.18%, #28F53C 90.99%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
          text-fill-color: transparent;
        }
      }
      .left-num{
        font-weight: 600;
        font-size: 24px;
        line-height: 33px;   
        padding-bottom:29px;
        text-align: left;
      }
     
    }
  }
`